import { useState, useMemo } from 'react'
import { Link } from 'react-router-dom'
import MetaTags from '../components/MetaTags'
import { imageUrl } from '../lib/images'

// All verified cars from EK Biler scrape with exact details and CDN images
const CARS_INVENTORY = [
  {
    id: 1,
    brand: 'Audi',
    model: 'Audi A6',
    variant: 'Avant 2,0 TDI S Tronic 190HK Stc 7g Aut.',
    price: '129.900 kr.',
    priceSub: 'Kontantpris',
    km: '249.000',
    year: '2015',
    fuel: 'Diesel',
    badge: 'Nyhed',
    sold: false,
    image: '1920.jpg',
  },
  {
    id: 2,
    brand: 'Audi',
    model: 'Audi A6',
    variant: 'Avant 3,0 TDI Competition Quattro Tiptr. 313HK Stc 7g Aut.',
    price: '259.900 kr.',
    priceSub: 'Kontantpris',
    km: '165.000',
    year: '2014',
    fuel: 'Diesel',
    badge: 'Nyhed',
    sold: false,
    image: '1920_7b1ac84e.jpg',
  },
  {
    id: 3,
    brand: 'Audi',
    model: 'Audi Q2',
    variant: '1,4 TFSI Sport S Tronic 150HK 5d 7g Aut.',
    price: '-',
    priceSub: 'Solgt',
    km: '97.000',
    year: '2018',
    fuel: 'Benzin',
    badge: 'Solgt',
    sold: true,
    image: '1920.jpg',
  },
  {
    id: 4,
    brand: 'Audi',
    model: 'Audi A4',
    variant: '2,0 TDI 136HK 6g',
    price: '64.900 kr.',
    priceSub: 'Kontantpris',
    km: '251.000',
    year: '2011',
    fuel: 'Diesel',
    sold: false,
    image: '1920.jpg',
  },
  {
    id: 5,
    brand: 'Cupra',
    model: 'Cupra Formentor',
    variant: '1,4 TSI Plugin-hybrid DSG 204HK 5d 6g Aut.',
    price: '199.000 kr.',
    priceSub: 'Kontantpris',
    km: '49.000',
    year: '2022',
    fuel: 'Plug-in hybrid (Benzin / El)',
    sold: false,
    image: '1920_4d663826.jpg',
  },
  {
    id: 6,
    brand: 'Ford',
    model: 'Ford Fiesta',
    variant: '1,2 Trend 82HK 5d',
    price: '24.900 kr.',
    priceSub: 'Kontantpris',
    km: '166.000',
    year: '2012',
    fuel: 'Benzin',
    sold: false,
    image: '1920_a8b889f3.jpg',
  },
  {
    id: 7,
    brand: 'Hyundai',
    model: 'Hyundai Kona',
    variant: 'EL Advanced 204HK 5d Aut.',
    price: '-',
    priceSub: 'Solgt',
    km: '54.000',
    year: '2021',
    fuel: 'El',
    badge: 'Solgt',
    sold: true,
    image: '1920_6f38042f.jpg',
  },
  {
    id: 8,
    brand: 'Mazda',
    model: 'Mazda CX-5',
    variant: '2,2 Skyactiv-D Vision 150HK 5d 6g Aut.',
    price: '114.900 kr.',
    priceSub: 'Kontantpris',
    km: '151.000',
    year: '2017',
    fuel: 'Diesel',
    sold: false,
    image: '1920_f84a7a41.jpg',
  },
  {
    id: 9,
    brand: 'Mercedes-Benz',
    model: 'Mercedes-Benz Vito',
    variant: '116 A3 2,1 CDI BlueEfficiency Edition 163HK Van',
    price: '139.900 kr.',
    priceSub: 'Kontantpris ekskl. moms',
    km: '125.000',
    year: '2018',
    fuel: 'Diesel',
    sold: false,
    image: '1920_f0d35964.jpg',
  },
  {
    id: 10,
    brand: 'Mercedes-Benz',
    model: 'Mercedes-Benz A180 d',
    variant: '2,0 CDI 109HK 5d 6g',
    price: '14.900 kr.',
    priceSub: 'Kontantpris',
    km: '259.000',
    year: '2009',
    fuel: 'Diesel',
    sold: false,
    image: '1920_7d4e32d8.jpg',
  },
  {
    id: 11,
    brand: 'Mercedes-Benz',
    model: 'Mercedes-Benz E300 de',
    variant: 'T 2,0 Plugin-hybrid AMG Line 9G-Tronic 306HK Stc Aut.',
    price: '399.900 kr.',
    priceSub: 'Kontantpris',
    km: '99.000',
    year: '2021',
    fuel: 'Hybrid (Diesel / El)',
    sold: false,
    image: '1920_54c1c11a.jpg',
  },
  {
    id: 12,
    brand: 'Peugeot',
    model: 'Peugeot 308',
    variant: '1,6 HDI Access 92HK Stc',
    price: '19.900 kr.',
    priceSub: 'Kontantpris',
    km: '229.000',
    year: '2013',
    fuel: 'Diesel',
    sold: false,
    image: '1920_7ba4d096.jpg',
  },
  {
    id: 13,
    brand: 'Peugeot',
    model: 'Peugeot 508',
    variant: 'SW 1,6 HDI Active 114HK Stc',
    price: '24.900 kr.',
    priceSub: 'Kontantpris',
    km: '298.000',
    year: '2014',
    fuel: 'Diesel',
    sold: false,
    image: '1920_28a1ab93.jpg',
  },
  {
    id: 14,
    brand: 'Seat',
    model: 'Seat Leon',
    variant: '1,4 TSI ACT FR Start/Stop DSG 150HK Stc 7g Aut.',
    price: '64.900 kr.',
    priceSub: 'Kontantpris',
    km: '309.000',
    year: '2017',
    fuel: 'Benzin',
    sold: false,
    image: '1920_d44da423.jpg',
  },
  {
    id: 15,
    brand: 'Seat',
    model: 'Seat Leon',
    variant: 'Sportstourer 1,5 TSI FR DSG 150HK Stc 7g Aut.',
    price: '-',
    priceSub: 'Solgt',
    km: '76.000',
    year: '2020',
    fuel: 'Benzin',
    badge: 'Solgt',
    sold: true,
    image: '1920_ebe4806c.jpg',
  },
  {
    id: 16,
    brand: 'Seat',
    model: 'Seat Ibiza',
    variant: '1,0 TSI FR DSG 110HK 5d 7g Aut.',
    price: '164.900 kr.',
    priceSub: 'Kontantpris',
    km: '75.000',
    year: '2022',
    fuel: 'Benzin',
    sold: false,
    image: '1920_b2ed4a5b.jpg',
  },
  {
    id: 17,
    brand: 'Seat',
    model: 'Seat Leon',
    variant: 'Sportstourer 1,5 e-TSI Mild hybrid FR DSG 150HK Stc 7g Aut.',
    price: '-',
    priceSub: 'Solgt',
    km: '77.000',
    year: '2021',
    fuel: 'Benzin',
    badge: 'Solgt',
    sold: true,
    image: '1920_7e7cf81b.jpg',
  },
  {
    id: 18,
    brand: 'Seat',
    model: 'Seat Tarraco',
    variant: '2,0 TDI Xcellence 4DRIVE DSG 190HK 5d 7g Aut.',
    price: '299.000 kr.',
    priceSub: 'Kontantpris',
    km: '115.000',
    year: '2020',
    fuel: 'Diesel',
    sold: false,
    image: '1920_82769dba.jpg',
  },
  {
    id: 19,
    brand: 'Skoda',
    model: 'Skoda Kodiaq',
    variant: '2,0 TDI AdBlue Style DSG 150HK 5d 7g Aut.',
    price: '259.900 kr.',
    priceSub: 'Kontantpris',
    km: '133.000',
    year: '2021',
    fuel: 'Diesel',
    sold: false,
    image: '1920_f141c8bb.jpg',
  },
  {
    id: 20,
    brand: 'Skoda',
    model: 'Skoda Octavia',
    variant: 'Combi 1,0 eTSI Mild hybrid Style DSG 110HK Stc 7g Aut.',
    price: '209.900 kr.',
    priceSub: 'Kontantpris',
    km: '79.000',
    year: '2022',
    fuel: 'Benzin',
    sold: false,
    image: '1920_011b7e38.jpg',
  },
  {
    id: 21,
    brand: 'Skoda',
    model: 'Skoda Superb',
    variant: 'Combi 1,4 TSI ACT Style DSG 150HK Stc 7g Aut.',
    price: '-',
    priceSub: 'Solgt',
    km: '149.000',
    year: '2018',
    fuel: 'Benzin',
    badge: 'Solgt',
    sold: true,
    image: '1920_770d32cc.jpg',
  },
  {
    id: 22,
    brand: 'Skoda',
    model: 'Skoda Octavia',
    variant: 'Combi 1,4 TSI Tour de France DSG 150HK Stc Aut.',
    price: '79.900 kr.',
    priceSub: 'Kontantpris',
    km: '236.000',
    year: '2016',
    fuel: 'Benzin',
    sold: false,
    image: '1920_1b1cd116.jpg',
  },
  {
    id: 23,
    brand: 'Skoda',
    model: 'Skoda Kodiaq',
    variant: '7 Sæder 2,0 TDI AdBlue Sportline DSG 150HK 5d 7g Aut.',
    price: '-',
    priceSub: 'Solgt',
    km: '115.000',
    year: '2021',
    fuel: 'Diesel',
    badge: 'Solgt',
    sold: true,
    image: '1920_d2199be8.jpg',
  },
  {
    id: 24,
    brand: 'Skoda',
    model: 'Skoda Octavia',
    variant: 'Combi 1,5 eTSI Sportline DSG 150HK Stc Aut.',
    price: '-',
    priceSub: 'Solgt',
    km: '129.000',
    year: '2021',
    fuel: 'Benzin',
    badge: 'Solgt',
    sold: true,
    image: '1920_f8eb6214.jpg',
  },
  {
    id: 25,
    brand: 'Skoda',
    model: 'Skoda Octavia',
    variant: 'Combi 1,5 TSI ACT Style DSG 150HK Stc 7g Aut.',
    price: '134.900 kr.',
    priceSub: 'Kontantpris',
    km: '175.000',
    year: '2019',
    fuel: 'Benzin',
    sold: false,
    image: '1920_7ca0191e.jpg',
  },
  {
    id: 26,
    brand: 'VW',
    model: 'VW ID.4',
    variant: 'EL Pro 286HK 5d Aut.',
    price: '314.900 kr.',
    priceSub: 'Kontantpris',
    km: '34.000',
    year: '2024',
    fuel: 'El',
    sold: false,
    image: '1920_6aedc836.jpg',
  },
  {
    id: 27,
    brand: 'VW',
    model: 'VW Golf',
    variant: 'Variant 1,6 BlueMotion TDI DPF Trendline 105HK Stc',
    price: '39.900 kr.',
    priceSub: 'Kontantpris',
    km: '344.000',
    year: '2012',
    fuel: 'Diesel',
    badge: 'Nyhed',
    sold: false,
    image: '1920_ae60767b.jpg',
  },
  {
    id: 28,
    brand: 'VW',
    model: 'VW Tiguan',
    variant: '1,5 TSI EVO ACT Highline Team DSG 150HK 5d 7g Aut.',
    price: '229.900 kr.',
    priceSub: 'Kontantpris',
    km: '122.000',
    year: '2020',
    fuel: 'Benzin',
    sold: false,
    image: '1920_d1447ebe.jpg',
  },
  {
    id: 29,
    brand: 'VW',
    model: 'VW T-Roc',
    variant: '1,5 TSI ACT R-Line DSG 150HK 5d Aut.',
    price: '182.900 kr.',
    priceSub: 'Kontantpris',
    km: '142.000',
    year: '2020',
    fuel: 'Benzin',
    sold: false,
    image: '1920_8ffe9668.jpg',
  },
  {
    id: 30,
    brand: 'VW',
    model: 'VW Tiguan',
    variant: '1,5 TSI EVO ACT Elegance DSG 150HK 5d 7g Aut.',
    price: '279.900 kr.',
    priceSub: 'Kontantpris',
    km: '94.000',
    year: '2021',
    fuel: 'Benzin',
    sold: false,
    image: '1920_c50e3510.jpg',
  },
  {
    id: 31,
    brand: 'VW',
    model: 'VW ID.4',
    variant: 'EL Pro 75 Years Edition Performan 204HK 5d Aut.',
    price: '-',
    priceSub: 'Solgt',
    km: '66.000',
    year: '2024',
    fuel: 'El',
    badge: 'Solgt',
    sold: true,
    image: '1920_7b83f64e.jpg',
  },
  {
    id: 32,
    brand: 'VW',
    model: 'VW up',
    variant: '1,0 MPI BMT Move 60HK 5d',
    price: '-',
    priceSub: 'Solgt',
    km: '176.000',
    year: '2018',
    fuel: 'Benzin',
    badge: 'Solgt',
    sold: true,
    image: '1920_5fb1c811.jpg',
  },
  {
    id: 33,
    brand: 'Volvo',
    model: 'Volvo XC90',
    variant: '2,0 D5 Inscription AWD 225HK 5d 8g Aut.',
    price: '419.900 kr.',
    priceSub: 'Kontantpris',
    km: '186.000',
    year: '2016',
    fuel: 'Diesel',
    sold: false,
    image: '1920_4c212db4.jpg',
  },
]

const BRANDS = [
  'Alle mærker',
  'Audi',
  'Cupra',
  'Ford',
  'Hyundai',
  'Mazda',
  'Mercedes-Benz',
  'Peugeot',
  'Seat',
  'Skoda',
  'Volvo',
  'VW',
]

const FUEL_TYPES = [
  'Alle brændstoffer',
  'Benzin',
  'Diesel',
  'El',
  'Hybrid (Diesel / El)',
  'Plug-in hybrid (Benzin / El)',
]

export default function BrugteBilerPage({ settings }) {
  const [selectedBrand, setSelectedBrand] = useState('Alle mærker')
  const [selectedFuel, setSelectedFuel] = useState('Alle brændstoffer')
  const [hideSold, setHideSold] = useState(false)

  const phone = settings?.phone || '22 18 73 30'
  const phoneRaw = settings?.phone_raw || '22187330'
  const email = settings?.email || 'steen@ekbiler.dk'
  const indicataUrl =
    settings?.indicata_url ||
    'https://lg.indicata.com/#/?dealerId=156f3c15-a501-4045-bf19-5598ec416fd9'

  const filteredCars = useMemo(() => {
    return CARS_INVENTORY.filter((car) => {
      if (selectedBrand !== 'Alle mærker' && car.brand !== selectedBrand) return false
      if (selectedFuel !== 'Alle brændstoffer' && car.fuel !== selectedFuel) return false
      if (hideSold && car.sold) return false
      return true
    })
  }, [selectedBrand, selectedFuel, hideSold])

  return (
    <>
      <MetaTags
        title="Brugte biler til salg nær Billund & Grindsted | Se hele udvalget"
        description="Hos EK Biler nær Billund og Grinsted finder du et stort udvalg af brugte biler. Vi har brugte biler i alle prisklasser og mærker | se mere"
        ogTitle="Brugte biler til salg nær Billund & Grindsted | Se hele udvalget"
        ogDescription="Hos EK Biler nær Billund og Grinsted finder du et stort udvalg af brugte biler. Vi har brugte biler i alle prisklasser og mærker | se mere"
        ogImage={imageUrl('img-8054-scaled.jpg', 'width=1200,quality=85,format=auto')}
      />

      {/* Header Banner */}
      <section className="bg-[#14171a] text-white py-12 sm:py-16 border-b border-[#262c33]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="max-w-3xl space-y-3">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-red-950/70 border border-red-800 text-red-400 text-xs font-bold uppercase tracking-wider">
              <i className="fa-solid fa-car" aria-hidden="true" />
              <span>Kvalitetsbiler med tryghed</span>
            </div>
            <h1 className="text-3xl sm:text-5xl font-extrabold tracking-tight text-white">
              Brugte biler
            </h1>
            <p className="text-gray-300 text-base sm:text-lg leading-relaxed">
              Hos EK Biler i Hejnsvig nær Billund og Grindsted finder du et stort udvalg af brugte
              biler i alle prisklasser og mærker. Alle biler er grundigt klargjort og serviceret på
              eget autoværksted.
            </p>
          </div>
        </div>
      </section>

      {/* Filter and Stats Bar */}
      <section className="bg-gray-100 border-b border-gray-200 py-6 shadow-xs">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 flex flex-col md:flex-row items-stretch md:items-center justify-between gap-4">
          <div className="flex flex-wrap items-center gap-3">
            {/* Brand select */}
            <div>
              <label htmlFor="filter-brand" className="sr-only">
                Vælg mærke
              </label>
              <select
                id="filter-brand"
                value={selectedBrand}
                onChange={(e) => setSelectedBrand(e.target.value)}
                className="bg-white border border-gray-300 text-gray-800 rounded-lg px-3 py-2 text-sm font-semibold focus:outline-none focus:ring-2 focus:ring-red-500 shadow-xs"
              >
                {BRANDS.map((b) => (
                  <option key={b} value={b}>
                    {b}
                  </option>
                ))}
              </select>
            </div>

            {/* Fuel select */}
            <div>
              <label htmlFor="filter-fuel" className="sr-only">
                Vælg brændstof
              </label>
              <select
                id="filter-fuel"
                value={selectedFuel}
                onChange={(e) => setSelectedFuel(e.target.value)}
                className="bg-white border border-gray-300 text-gray-800 rounded-lg px-3 py-2 text-sm font-semibold focus:outline-none focus:ring-2 focus:ring-red-500 shadow-xs"
              >
                {FUEL_TYPES.map((f) => (
                  <option key={f} value={f}>
                    {f}
                  </option>
                ))}
              </select>
            </div>

            {/* Hide sold checkbox */}
            <label className="flex items-center gap-2 text-sm text-gray-700 font-medium cursor-pointer bg-white border border-gray-300 px-3 py-2 rounded-lg shadow-xs select-none">
              <input
                type="checkbox"
                checked={hideSold}
                onChange={(e) => setHideSold(e.target.checked)}
                className="rounded text-[#e20019] focus:ring-red-500"
              />
              <span>Skjul solgte biler</span>
            </label>
          </div>

          <div className="flex items-center justify-between md:justify-end gap-4">
            <span className="text-sm font-bold text-gray-800">
              Viser {filteredCars.length} af {CARS_INVENTORY.length} biler
            </span>
            <a
              href={indicataUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-1.5 text-xs font-bold bg-[#e20019] hover:bg-[#b80014] text-white px-3.5 py-2 rounded-lg transition-colors shadow-xs whitespace-nowrap"
            >
              <span>Beregn byttepris online</span>
              <i className="fa-solid fa-arrow-up-right-from-square text-[10px]" aria-hidden="true" />
            </a>
          </div>
        </div>
      </section>

      {/* Cars Grid */}
      <section className="py-12 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          {filteredCars.length === 0 ? (
            <div className="text-center py-16 bg-gray-50 rounded-2xl border border-gray-200">
              <i className="fa-solid fa-car text-gray-300 text-4xl mb-3" aria-hidden="true" />
              <h3 className="text-lg font-bold text-gray-800">Ingen biler matcher søgningen</h3>
              <p className="text-sm text-gray-500 mt-1">Prøv at nulstille dine filtre ovenfor.</p>
              <button
                type="button"
                onClick={() => {
                  setSelectedBrand('Alle mærker')
                  setSelectedFuel('Alle brændstoffer')
                  setHideSold(false)
                }}
                className="mt-4 inline-flex items-center gap-2 px-4 py-2 bg-gray-900 text-white rounded-lg text-xs font-bold"
              >
                Nulstil filtre
              </button>
            </div>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
              {filteredCars.map((car) => (
                <div
                  key={car.id}
                  className="bg-white border border-gray-200 rounded-2xl overflow-hidden shadow-xs hover:shadow-lg hover:border-gray-300 transition-all flex flex-col justify-between group"
                >
                  <div>
                    {/* Image with badge */}
                    <div className="relative aspect-[16/10] bg-gray-100 overflow-hidden">
                      <img
                        src={imageUrl(car.image, 'width=600,quality=80,format=auto')}
                        alt={`${car.model} - ${car.variant}`}
                        className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                        loading="lazy"
                      />
                      {car.badge && (
                        <div
                          className={`absolute top-3 left-3 text-xs font-extrabold px-3 py-1 rounded-md uppercase tracking-wide shadow-md ${
                            car.badge === 'Solgt'
                              ? 'bg-gray-900/90 text-gray-300 border border-gray-700'
                              : 'bg-[#e20019] text-white'
                          }`}
                        >
                          {car.badge}
                        </div>
                      )}
                      <div className="absolute bottom-2 right-2 bg-black/60 backdrop-blur-xs text-white text-[11px] font-semibold px-2 py-0.5 rounded">
                        {car.fuel}
                      </div>
                    </div>

                    {/* Details */}
                    <div className="p-5">
                      <div className="text-xs font-bold text-gray-400 uppercase tracking-wider mb-1">
                        {car.brand}
                      </div>
                      <h3 className="text-lg font-bold text-gray-900 leading-snug group-hover:text-[#e20019] transition-colors">
                        {car.model}
                      </h3>
                      <p className="text-xs text-gray-500 mt-1 line-clamp-2 leading-relaxed">
                        {car.variant}
                      </p>

                      {/* Specs pills */}
                      <div className="mt-4 pt-3 border-t border-gray-100 grid grid-cols-3 gap-2 text-center text-xs">
                        <div className="bg-gray-50 p-2 rounded-lg">
                          <div className="text-gray-400 text-[10px] uppercase font-bold">Årgang</div>
                          <div className="font-bold text-gray-800">{car.year}</div>
                        </div>
                        <div className="bg-gray-50 p-2 rounded-lg">
                          <div className="text-gray-400 text-[10px] uppercase font-bold">Kilometer</div>
                          <div className="font-bold text-gray-800">{car.km} km</div>
                        </div>
                        <div className="bg-gray-50 p-2 rounded-lg">
                          <div className="text-gray-400 text-[10px] uppercase font-bold">Drivmiddel</div>
                          <div className="font-bold text-gray-800 truncate" title={car.fuel}>
                            {car.fuel.split(' ')[0]}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Price and Contact CTA */}
                  <div className="p-5 pt-0 mt-2">
                    <div className="flex items-baseline justify-between mb-3 border-t border-gray-100 pt-3">
                      <div>
                        <div className="text-xl font-extrabold text-gray-900">{car.price}</div>
                        <div className="text-[11px] text-gray-500">{car.priceSub}</div>
                      </div>
                      {!car.sold && (
                        <div className="text-xs font-semibold text-emerald-700 bg-emerald-50 px-2 py-1 rounded">
                          Klar til levering
                        </div>
                      )}
                    </div>

                    <div className="flex flex-col sm:flex-row gap-2">
                      <a
                        href={`tel:${phoneRaw}`}
                        className="w-full text-center py-2 px-3 border border-gray-300 hover:bg-gray-50 rounded-lg text-xs font-bold text-gray-800 transition-colors whitespace-nowrap"
                      >
                        <i className="fa-solid fa-phone text-[#e20019] mr-1" aria-hidden="true" />
                        <span>Ring op</span>
                      </a>
                      <Link
                        to="/kontakt"
                        className="w-full text-center py-2 px-3 bg-gray-900 hover:bg-black text-white rounded-lg text-xs font-bold transition-colors whitespace-nowrap"
                      >
                        Forespørgsel
                      </Link>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </section>

      {/* Verbatim Informative Sections from Scrape */}
      <section className="py-16 bg-gray-50 border-t border-gray-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
            <div className="space-y-6">
              <h2 className="text-2xl sm:text-3xl font-extrabold text-gray-900 tracking-tight">
                Brugte biler til salg nær Billund og Grindsted
              </h2>
              <p className="text-sm sm:text-base text-gray-700 leading-relaxed">
                Leder du efter en pålidelig brugt bil med god historik og ærlig rådgivning? Hos EK
                Biler i Hejnsvig har vi specialiseret os i at levere kvalitetsbrugte biler. Vi har
                biler i mange prisklasser og kategorier – fra kompakte bybiler til rummelige
                familiebiler og moderne elbiler.
              </p>
              <p className="text-sm sm:text-base text-gray-700 leading-relaxed">
                Vi udvælger kun biler, vi selv kan stå inde for. Alle biler bliver testet, klargjort og
                serviceret på vores eget autoværksted, før de kommer til salg. Du får derfor ikke kun en
                god bil – du får også ro i maven.
              </p>

              <h3 className="text-xl font-bold text-gray-900 pt-2">
                Stort udvalg af brugte biler og elbiler
              </h3>
              <p className="text-sm text-gray-700">
                Hos os finder du et varieret udvalg af brugte biler i alle størrelser, motortyper og
                prisklasser. Vores sortiment omfatter typisk:
              </p>
              <ul className="list-disc list-inside space-y-1.5 text-sm text-gray-700 pl-2">
                <li>Brændstoføkonomiske pendlerbiler</li>
                <li>Stationcars til familien</li>
                <li>SUV’er og crossovers</li>
                <li>Varebiler og mindre erhvervskøretøjer</li>
                <li>Elbiler og plug-in hybrider</li>
              </ul>
            </div>

            <div className="space-y-6">
              <h3 className="text-xl font-bold text-gray-900">
                Find den bil, der passer til dine behov
              </h3>
              <p className="text-sm text-gray-700 leading-relaxed">
                Vi sætter en ære i at rådgive dig personligt og ærligt. Vi spørger ind til dit
                kørselsbehov, budget, ønsket udstyr og fremtidige planer – og foreslår biler, der
                matcher det hele.
              </p>
              <p className="text-sm text-gray-700 leading-relaxed">
                Er du usikker på, om det skal være el, benzin eller diesel? Vi hjælper dig med at
                træffe det rigtige valg – både teknisk og økonomisk. Vi har solgt mange brugte elbiler,
                og vi kender både fordele og ulemper, afhængigt af din hverdag.
              </p>

              <div className="bg-white p-6 rounded-2xl border border-gray-200 shadow-sm space-y-3">
                <h4 className="font-bold text-gray-900 text-base">Vi tager din bil i bytte</h4>
                <p className="text-sm text-gray-600 leading-relaxed">
                  Har du en bil, du vil skille dig af med? Vi giver en fair vurdering og tilbyder gerne
                  bytte, så du kan bruge værdien direkte i handlen. Det er hurtigt, nemt og økonomisk
                  fordelagtigt.
                </p>
                <div className="pt-2">
                  <a
                    href={indicataUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center gap-2 text-sm font-bold text-[#e20019] hover:underline"
                  >
                    <span>Beregn din byttepris online her &rarr;</span>
                  </a>
                </div>
              </div>

              <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-3 sm:gap-4 pt-2 w-full sm:w-auto">
                <Link
                  to="/finansering"
                  className="w-full sm:w-auto inline-flex items-center justify-center gap-2 bg-[#14171a] hover:bg-black text-white px-5 py-3 rounded-lg text-sm font-bold transition-colors text-center"
                >
                  <span>Læs om finansiering &amp; forsikring</span>
                </Link>
                <a
                  href={`tel:${phoneRaw}`}
                  className="w-full sm:w-auto inline-flex items-center justify-center gap-2 border border-gray-300 hover:bg-gray-100 text-gray-800 px-5 py-3 rounded-lg text-sm font-bold transition-colors text-center"
                >
                  <span>Book en prøvetur på {phone}</span>
                </a>
              </div>
            </div>
          </div>

          {/* FAQs from Scrape */}
          <div className="mt-16 pt-12 border-t border-gray-200">
            <h3 className="text-2xl font-bold text-gray-900 mb-8 text-center">
              Ofte stillede spørgsmål om køb af brugte biler hos EK Biler
            </h3>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-5xl mx-auto">
              <div className="bg-white p-6 rounded-xl border border-gray-200 shadow-xs">
                <h4 className="font-bold text-gray-900 text-base mb-2">
                  Har I både elbiler og benzin/dieselbiler til salg?
                </h4>
                <p className="text-sm text-gray-600 leading-relaxed">
                  Ja, vi har løbende både elbiler, plug-in hybrider, benzin- og dieselbiler på lager – og
                  vi hjælper dig gerne med at vælge den rette løsning.
                </p>
              </div>

              <div className="bg-white p-6 rounded-xl border border-gray-200 shadow-xs">
                <h4 className="font-bold text-gray-900 text-base mb-2">
                  Hvordan ved jeg, at bilen er i god stand?
                </h4>
                <p className="text-sm text-gray-600 leading-relaxed">
                  Alle vores biler bliver grundigt gennemgået og klargjort på vores eget værksted, inden
                  de sættes til salg. Du får altid fuld indsigt i bilens stand og historik.
                </p>
              </div>

              <div className="bg-white p-6 rounded-xl border border-gray-200 shadow-xs">
                <h4 className="font-bold text-gray-900 text-base mb-2">
                  Kan jeg få finansiering uden udbetaling?
                </h4>
                <p className="text-sm text-gray-600 leading-relaxed">
                  Ja, vi tilbyder både finansiering med og uden udbetaling gennem samarbejdspartnere som
                  Santander og Accept Auto. Vi giver dig gerne et konkret tilbud.
                </p>
              </div>

              <div className="bg-white p-6 rounded-xl border border-gray-200 shadow-xs">
                <h4 className="font-bold text-gray-900 text-base mb-2">
                  Tager I min gamle bil i bytte?
                </h4>
                <p className="text-sm text-gray-600 leading-relaxed">
                  Ja, vi tager gerne din nuværende bil i bytte – og vi vurderer den realistisk og
                  hurtigt, så handlen bliver enkel og fair.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}
